import GenericRESTClient from '~api/generic-rest-client';
import { bytesToSize } from '../utils/bytesToSize';
export class RESTBackendClient extends GenericRESTClient {
    async createToken() {
        return this.makeRequest('POST', `/api/UserAuthTokens`);
    }
    getCrossDomainCookiesURL(to, locationOrigin) {
        let fullTo = to;
        if (fullTo.startsWith('/')) {
            fullTo = `${this.url}${to}`;
            if (fullTo.startsWith('/')) {
                fullTo = `${locationOrigin}${fullTo}`;
            }
        }
        return `${this.url}/utk/sessions/check?continue=${encodeURIComponent(fullTo)}`;
    }
    async updateAvatar(newAvatar) {
        const initiateRes = await this.makeRequest('POST', `${this.url}/user/avatar/upload`);
        if (initiateRes.type === 'error') {
            throw new Error(`Failed to initiate upload: ${initiateRes.error}`);
        }
        if (newAvatar.size > initiateRes.data.max_size) {
            throw new Error(`Image is too large (max size: ${bytesToSize(initiateRes.data.max_size)})`);
        }
        // Backend is way too smart here. I will cast whatever I'm trying to upload to image/png, as the MIME type is not necessarily detected correctly.
        const uploadRes = await this.makeRequest(initiateRes.data.method, initiateRes.data.url, newAvatar, false);
        if (uploadRes.type === 'error') {
            throw new Error(`Failed to upload image: ${uploadRes.error}`);
        }
        const completeRes = await this.makeRequest('POST', `${this.url}/user/avatar/upload-complete`, {
            id: initiateRes.data.id,
        });
        if (completeRes.type === 'error') {
            throw new Error(`Failed to complete upload: ${completeRes.error}`);
        }
    }
    async fetchBalance() {
        return this.makeRequest('GET', `${this.url}/user/balance`);
    }
    async fetchTokenTransfers(address, unclaimed, pagination) {
        const search = new URLSearchParams();
        if (unclaimed) {
            search.set('unclaimed', 'true');
        }
        if (pagination?.before !== undefined) {
            search.set('before', pagination.before);
        }
        if (pagination?.after !== undefined) {
            search.set('after', pagination.after);
        }
        if (pagination?.first !== undefined) {
            search.set('first', pagination.first.toString());
        }
        if (pagination?.last !== undefined) {
            search.set('last', pagination.last.toString());
        }
        return this.makeRequest('GET', `${this.url}/wallet/${address.toLowerCase()}/token-transfers?${search.toString()}`);
    }
    async claimTokenTrasfer(address, txId, logIndex, signature) {
        return this.makeRequest('POST', `${this.url}/wallet/${address}/token-transfers/${txId}/${logIndex}/claim`, { signature });
    }
    async checkReferral(referral) {
        const rsp = await this.makeRequest('GET', `${this.url}/api/check-referral?referral=${encodeURIComponent(referral)}`);
        return rsp.status === 200;
    }
    async fetchErrorToken() {
        const rsp = await this.makeRequest('GET', `${this.url}/users/error-token`);
        if (rsp.type === 'error') {
            return 'failed-idm-error-token';
        }
        return rsp.data.token;
    }
    async fetchTheme() {
        const rsp = await this.makeRequest('GET', `${this.url}/api/theme`);
        if (rsp.type === 'error') {
            throw new Error(`Failed to load the platform theme: ${rsp.error}`);
        }
        return rsp.data;
    }
}
export default function restApi() {
    return new RESTBackendClient(``);
}
